import housekeeperAccommodationService from '@services/housekeeperAccommodationService';
import accommodationService from '@services/accommodationService';

export default {
  data() {
    return {
      autocompleteHousekeeperAccommodationQuery: 'name',
    };
  },
  methods: {
    autocompleteHousekeeperAccommodation(e) {
      return housekeeperAccommodationService.autocomplete(e);
    },
    autocompleteAccommodationById(e) {
      return accommodationService.accommodationDisplay(e);
    },
  },
};
